export const GTM_FORM_CATALOG_REQUEST = 'demande catalogue';
export const GTM_FORM_CHANGE_EMAIL = 'modification email';
export const GTM_FORM_CHANGE_PASSWORD = 'modification mot de passe';
export const GTM_FORM_FORGOT_CUSTOMER_NUMBER = 'oubli numéro client';
export const GTM_FORM_MANAGE_SUBSCRIPTION = 'gestion abonnement';
export const GTM_FORM_NEWSLETTER = 'newsletter';
export const GTM_FORM_NEWSLETTER_SUBSCRIBE = 'inscription newsletter';
export const GTM_FORM_NEWSLETTER_UNSUBSCRIBE = 'désinscription newsletter';
